import { RootState } from "../../../../setup/redux/store";
import * as lc from "../../localstorage/index";
import * as api from "../services/firebaseAuthService";
import { connect, ConnectedProps, useDispatch, useSelector } from "react-redux";
import * as auth from "../redux/AuthSlice";
import { FC, useEffect, useRef, useState } from "react";
import { startUserPresence } from "../services/userPresenceService";
import * as Log from "../../../../util/SDayslogger";
import { useNavigate } from "react-router-dom";
import { isDevelopment } from "../../../../config/env";
import { useTranslation } from "react-i18next";

const mapState = (state: RootState) => ({ auth: state.Auth });
const connector = connect(mapState, auth.AuthSlice.actions);
type PropsFromRedux = ConnectedProps<typeof connector>;

const AuthInit: FC<PropsFromRedux> = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [showLoading, setShowLoading] = useState(true);
  const didRequest = useRef(false);
  const currentUser = lc.getItemLC(lc.LCName.User);
  const nav = useNavigate();
  let collablist = useSelector((state: RootState) => state.Chat.chatList); //list Collaboration
  let userCollablist = useSelector(
    (state: RootState) => state.Chat.userChatList
  ); //list Collaboration

  // let requestUser;
  useEffect(() => {
    const screentime = new Date().getTime();
    const sessionid = lc.getItemLC(lc.LCName.SessionID);
    let stopPresence: (() => void) | undefined;

    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          didRequest.current = true;
          if (currentUser != null) {
            // Add timeout to prevent hanging on AuthUser call
            const authPromise = AuthUser(currentUser);
            const timeoutPromise = new Promise((_, reject) => {
              setTimeout(
                () => reject(new Error("Authentication timeout")),
                15000
              );
            });

            await Promise.race([authPromise, timeoutPromise]).then(
              (response) => {
                dispatch(props.setAuthUser(JSON.stringify(currentUser)));
                dispatch(props.setAuth(response as boolean));
                dispatch(props.setSessionUser(screentime));
                stopPresence = startUserPresence(currentUser.uid, sessionid);

                console.log("Init Get All Collaboration");
                const user = {
                  company: lc.getItemLC(lc.LCName.CompanyID),
                  uid: currentUser.uid,
                };

                /***
                 * Replace With Pesist Redux
                 * **/

                // if (!collablist || collablist.length <= 0) {
                // Chat
                //   // .fetchCollaborations(user.uid, user.company)
                //   .fetchCollaborations(user.uid)
                //   .then(collabs => dispatch(chat.setChatList(collabs)))
                // }
                // if (!userCollablist || userCollablist.length <= 0) {
                // Chat
                //   .fetchFriendCollaborations(user.uid)
                //   .then(collabs => dispatch(chat.setUserChatList(collabs)))
                // }
              }
            );
          }
        }
      } catch (error) {
        console.error("AuthInit error:", error);
        if (!didRequest.current) {
          // If it's a timeout error, still set auth to true for tests
          if (error.message === "Authentication timeout" && isDevelopment) {
            console.warn(
              "AuthInit: Authentication timeout in development, proceeding anyway"
            );
            dispatch(props.setAuthUser(JSON.stringify(currentUser)));
            dispatch(props.setAuth(true));
          } else {
            //dispatch for log out
            dispatch(props.setAuth(false));
          }
        }
      } finally {
        setShowLoading(false);
      }
    };

    if (currentUser) {
      requestUser();
    } else {
      //dispacth for log out
      lc.removeSession();
      dispatch(props.setAuth(false));
      setShowLoading(false);
      lc.removeSession();
    }

    return () => {
      stopPresence?.();
    };
    // eslint-disable-next-line
  }, []);

  // Cross-tab session sync: detect logout or account switch in another tab
  useEffect(() => {
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key !== "User") return;

      if (event.newValue === null) {
        // User key removed — logout happened in another tab
        dispatch(props.setAuth(false));
        nav("/auth");
      } else {
        // User key changed — different account logged in, reload to reset state
        window.location.reload();
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
    // eslint-disable-next-line
  }, []);

  return showLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">{t("Login.Button.Loading")}</span>
      </div>
    </div>
  ) : (
    <>{props.children}</>
  );
};

export default connector(AuthInit);

function AuthUser(currentUser: any): Promise<boolean> {
  Log.debug(`Session AuthUser ${JSON.stringify(currentUser)}`);
  return api.AuthUser(currentUser);
}
